import {useKeycloak} from "@react-keycloak/web"

import {clearAppStorage} from "@auth/utils/token"

import {localStorageItemName} from "src/constants/local-storage-item-name"

/**
 * Shape of the object returned by the `useKeycloakLogout` hook.
 *
 * @property {() => void} logout - A function that clears the app's local state and ends the Keycloak session.
 */
export interface KeycloakLogout {
    logout: () => void
}

/**
 * This destroys the SSO session, so the next sign-in is a full browser flow —
 * password plus MFA. Use it only for a deliberate sign-out. To recover from an
 * expired session, prefer `keycloak.login()`, which Keycloak can often satisfy
 * silently.
 *
 * @returns {KeycloakLogout} The `logout` function that clears the app's local state and ends the Keycloak
 * session..
 */
export const useKeycloakLogout = (): KeycloakLogout => {
    const {keycloak} = useKeycloak()

    /**
     * Clears the app's local state and ends the Keycloak session.
     */
    const logout = () => {
        sessionStorage.clear()
        clearAppStorage([localStorageItemName.columnView])
        keycloak.logout()
    }

    return {
        logout
    }
}
